import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, AlertController } from 'ionic-angular';

import { TenderMarketing, MasterMarketing as Master, UserMarketing as User } from '@providers/index';
import { ListProjectPage, LoginPage, ProfilePage } from '../index';

@Component({
  selector: 'page-dashboard-marketing',
  templateUrl: 'page.html'
})
export class DashboardPage {

  public barChartData:any[] = [
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: ''},
    {data: [0], label: 'Other'}
  ];
  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartType:string = 'bar';
  public barChartLegend:boolean = true;


  public doughnutChartLabels:string[] = ["OE = TBA","OE < 1 Millions","OE = 1 - 5 Millions","OE =  5 - 25 Millions","OE > 25 Millions","Other"];
  public doughnutChartData:number[] = [0,0,0,0,0,0];
  public doughnutChartColor = [
      {
        backgroundColor : ["#fff","#f4f4f5","#cdebfd","#b1dc99","#fbdb7a","#ef7596","#f4f4f5"]
      }
  ];
  public doughnutChartType:string = 'doughnut';
  
  user:any = {};

  tenderStat       :any = [];
  tenderByRate     :any = [];
  dataBar          :any = [];
  listPerDepartment:any = [];
  AllDepartment    =0;

  company             :any = [];
  branch              :any = [];
  sbu                 :any = [];
  stage               :any = [];
  company_all_selected:any = 1;
  branch_all_selected :any = 1;
  sbu_all_selected    :any = 1;
  company_selected     = [];
  branch_selected      = [];
  sbu_selected         = [];
  readyFilter          = 0;

  branch_user = false;
  sbu_user    = false;
  custom_user = false;

  company_ids = [];
  branch_ids  = [];
  sbu_ids     = [];

  filter_stage             :any = [];
  filter_stage_all_selected:any =  1;
  filter_stage_selected     = [];

  constructor(
    public navCtrl     : NavController,
    public toastCtrl   : ToastController,
    public loadingCtrl : LoadingController,
    public alertCtrl   : AlertController,
    public masterApi   : Master,
    public userApi     : User,
    public tenderApi   : TenderMarketing
  ) {
    console.log(this.userApi.akses);
    if(this.userApi.akses.lihat_tender_group_data=='branch'){
      this.branch_user = true;
    }
    if(this.userApi.akses.lihat_tender_group_data=='sbu'){
      this.sbu_user = true;
    }
    if(this.userApi.akses.lihat_tender_group_data=='fitur_user_data'){
      this.custom_user = true;
      if(!this.userApi.akses.lihat_tender_user_data.all_company){
        this.company_ids = this.userApi.akses.lihat_tender_user_data.company_ids.split(",");
        console.log('akses custom company_ids => ', this.company_ids);
      }if(!this.userApi.akses.lihat_tender_user_data.all_branch){
        this.branch_ids = this.userApi.akses.lihat_tender_user_data.branch_ids.split(",");
        console.log('akses custom branch_ids => ', this.branch_ids);
      }if(!this.userApi.akses.lihat_tender_user_data.all_sbu){
        this.sbu_ids = this.userApi.akses.lihat_tender_user_data.sbu_ids.split(",");
        console.log('akses custom sbu_ids => ', this.sbu_ids);
      }
    }

    this.getFilterStage();
    this.getCompany();
    this.getBranch();
    this.getSBU();
    this.getStage();
  }

  ionViewWillEnter() {

    if(this.userApi.akses.lihat_tender_group_data=='mine'){
      this.navCtrl.push(ListProjectPage, {
        params : {}
      });

    }
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getDataTenderStat();
  }

  ionViewDidEnter() {
    this.getDataTenderStat();
  }

  public getCompany(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.company(params).subscribe((resp:any) => {
      console.log("company data => ", resp.data);
      resp.data.forEach(rec => {
        if(this.branch_user){
          if(this.userApi.data.company_id==rec.id){
            rec.selected = 1;      
            this.company_selected.push(rec.id);
          }
        }else if(this.custom_user){
          if(this.userApi.akses.lihat_tender_user_data.all_company){
            rec.selected = 1;
            this.company_selected.push(rec.id);
          }else{
            this.company_ids.forEach(comp => {
              if(comp == rec.id){
                rec.selected = 1;
                this.company_selected.push(rec.id);
              }
            });
          }
        }else{
          rec.selected = 1;
          this.company_selected.push(rec.id);
        }
        
      });
      console.log(this.company_selected);
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      this.company = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
  
  public getBranch(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.branch(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.branch_user){
          if(this.userApi.data.hrm_company_office_id==rec.id){
            this.branch.push(rec);
            rec.selected = 1;
            this.branch_selected.push(rec.id);
          }
        }else if(this.custom_user){
          if(this.userApi.akses.lihat_tender_user_data.all_branch){
            this.branch = resp.data;
            rec.selected = 1;
            this.branch_selected.push(rec.id);
          }else{
            this.branch_ids.forEach(branch => {
              if(branch == rec.id){
                this.branch.push(rec);
                rec.selected = 1;
                this.branch_selected.push(rec.id);
              }
            });
          }
        }else{
          this.branch = resp.data;
          rec.selected = 1;
          this.branch_selected.push(rec.id);
        }
      });
      console.log(this.branch_selected);
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      // this.branch = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getSBU(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.sbu(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        if(this.custom_user){
          if(this.userApi.akses.lihat_tender_user_data.all_sbu){
            this.sbu = resp.data;
            rec.selected = 1;
            this.sbu_selected.push(rec.id);
          }else{
            this.sbu_ids.forEach(sbu => {
              if(sbu == rec.id){
                this.sbu.push(rec);
                rec.selected = 1;
                this.sbu_selected.push(rec.id);
              }
            });
          }
        }else{
          this.sbu = resp.data;
          rec.selected = 1;
          this.sbu_selected.push(rec.id);
        }
      });
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  public getFilterStage(){
    let params : {};
    this.masterApi.filterStage(params).subscribe((resp:any) => {
      resp.data.forEach(rec => {
        rec.selected = 1;
        this.filter_stage_selected.push(rec.id);
      });
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      this.filter_stage = resp.data;
    });
  }

  public getStage(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.masterApi.stage(params).subscribe((resp:any) => {
      this.stage = resp.data;
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  public getDataTenderStat(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params = {};
    this.tenderApi.getTenderStat(params).subscribe((resp:any) => {
      this.tenderStat = resp.data;
      this.tenderByRate = resp.data_by_rate;
      this.readyFilter++;
      if(this.readyFilter==6){
        this.changeFilter();
      }
      loading.dismiss();
    },(err) => {
      this.presentToast('Failed to Load Data.');
      loading.dismiss();
    });
  }

  filterBar(){
    this.dataBar =[];
    this.dataBar['other']=0;
    this.dataBar['all']=0;
      this.tenderStat.forEach(rec1 => {
        let andCompany = this.company_selected.indexOf(rec1.company_id);
        let andBranch  = this.branch_selected.indexOf(rec1.branch_id);
        let andSbu     = this.sbu_selected.indexOf(rec1.sbu_id);
        let andStage   = this.filter_stage_selected.indexOf(rec1.classification_id);
        if(andCompany!=-1 && andBranch!=-1 && andSbu!=-1 && andStage!=-1){
          if(this.dataBar[rec1.stage_id]==undefined){
              this.dataBar[rec1.stage_id] = 0;
          }
          this.dataBar[rec1.stage_id] += parseInt(rec1.tender_count);
          
        }
      });
      
      this.barChartData = [];
      this.stage.forEach(stg => {
        let jml = 0;
        if(this.dataBar[stg.id]){
          jml = parseInt(this.dataBar[stg.id]);
        }
        stg.show_stat = parseInt(stg.show_stat);
        if(stg.show_stat){
          this.barChartData.push({data: [jml], label: stg.stage});
        }else{
          this.dataBar['other'] += jml;
        }
        this.dataBar['all'] += jml;
      });
      this.barChartData.push({data: [this.dataBar['other']], label: 'Other'});
      this.barChartData.push({data: [this.dataBar['all']], label: 'All'});

    }

  filterDepartment(){
    let tempIndex = [];
    this.listPerDepartment = [];
    let i =0;
    this.AllDepartment = 0;
    let tempTenderStat = this.tenderStat;
    tempTenderStat.forEach( rec2 => {
      let andCompany = this.company_selected.indexOf(rec2.company_id);
      let andBranch = this.branch_selected.indexOf(rec2.branch_id);
      let andSbu = this.sbu_selected.indexOf(rec2.sbu_id);
      let andStage   = this.filter_stage_selected.indexOf(rec2.classification_id);
      if(andCompany!=-1 && andBranch!=-1 && andSbu!=-1 && andStage!=-1){
        if(tempIndex[rec2.dept_id]==undefined){
          let temp = {
            tender_count   : parseInt(rec2.tender_count),
            sbu_short_name : rec2.sbu_short_name,
            dept_id        : rec2.dept_id,
            dept_short_name: rec2.dept_short_name,
            stage_id       : rec2.stage_id
          }
          tempIndex[rec2.dept_id]=i;
          i++;
          this.listPerDepartment.push(temp);
        }
        else{
          this.listPerDepartment[ tempIndex[rec2.dept_id] ].tender_count += parseInt(rec2.tender_count);
        }
        this.AllDepartment += parseInt(rec2.tender_count); 
        
      }

    });
  }

  filterPie(){
    let data = [];
    let label = [];
    
    this.tenderByRate.forEach( rec2 => {
      let andCompany = this.company_selected.indexOf(rec2.company_id);
      let andSbu = this.sbu_selected.indexOf(rec2.sbu_id);
      let andBranch = this.branch_selected.indexOf(rec2.branch_id);
      if(rec2.rate==null){
        rec2.rate = 'Other';
      }
      if(andCompany!=-1 && andBranch!=-1 && andSbu!=-1){
        let i = label.indexOf(rec2.rate)
        if(i==-1){
          label.push(rec2.rate);
          data.push(rec2.tender_count);
        }
        else{
          data[ i ] = parseInt(data[i]) + parseInt(rec2.tender_count);
        }
      }

    });
    if(data.length==0){
      data = [0];
    }

    this.doughnutChartData = data;
    this.doughnutChartLabels = label;
    
  }

  public companyClick(i){
    if(this.branch_user || this.custom_user && !this.userApi.akses.lihat_tender_user_data.all_company){
      return;
    }
    this.company[i].selected = !this.company[i].selected;
    this.changeFilter('company');
  }

  public companyClickAll(){
    if(this.branch_user || this.custom_user && !this.userApi.akses.lihat_tender_user_data.all_company){
      return;
    }
    this.company_all_selected = !this.company_all_selected;
    this.company.forEach(rec => {
      rec.selected = this.company_all_selected;
    });
    this.changeFilter('company');
  }

  public branchClick(i){
    if(this.branch_user){
      return;
    }
    this.branch[i].selected = !this.branch[i].selected;
    this.changeFilter('branch');
  }

  public branchClickAll(){
    if(this.branch_user){
      return;
    }
    this.branch_all_selected = !this.branch_all_selected;
    this.branch.forEach(rec => {
      rec.selected = this.branch_all_selected;
    });
    this.changeFilter('branch');
  }

  public sbuClick(i){
    this.sbu[i].selected = !this.sbu[i].selected;
    this.changeFilter('sbu');
  }

  public sbuClickAll(){
    this.sbu_all_selected = !this.sbu_all_selected;
    this.sbu.forEach(rec => {
      rec.selected = this.sbu_all_selected;
    });
    this.changeFilter('sbu');
  }

  public stageClick(i){
    this.filter_stage[i].selected = !this.filter_stage[i].selected;
    this.changeFilter('stage');
  }
 
  public changeFilter(opt=''){
    if(opt=='sbu' || opt==''){
      let all = 0;
      if(this.custom_user && !this.userApi.akses.lihat_tender_user_data.all_sbu){
        all = 0;
      }else{
        all = 1
      }
      this.sbu_selected = [];
      this.sbu.forEach(rec => {
        if(rec.selected){
          this.sbu_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.sbu_all_selected = all;
    } 

    if(opt=='branch'  || opt==''){
      let all = 0;
      if(this.branch_user || this.custom_user && !this.userApi.akses.lihat_tender_user_data.all_branch){
        all = 0;
      }else{
        all = 1;
      }
      this.branch_selected = [];
      this.branch.forEach(rec => {
        if(rec.selected){
          this.branch_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.branch_all_selected = all;
    }

    if(opt=='company'  || opt==''){
      let all = 1;
      this.company_selected = [];
      this.company.forEach(rec => {
        if(rec.selected){
          this.company_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.company_all_selected = all;
    }

    if(opt=='stage' || opt==''){
      let all = 1;
      this.filter_stage_selected = [];
      this.filter_stage.forEach(rec => {
        if(rec.selected){
          this.filter_stage_selected.push(rec.id);
        }else{
          all = 0;
        }
      });
      this.filter_stage_all_selected = all;
    }

    this.filterBar();
    this.filterDepartment();
    this.filterPie();
  }

  // events
  public chartClicked(e:any):void {
    // if (e.active.length > 0) {
    //   var chartElement = e.active[0]._chart.getElementAtEvent(event);
    //   let select = chartElement[0]._model;
    // }
  }

  toListProject(dept_id='',branch_id='') {
    let params:any = {};
    if(dept_id!=''){
      params.dept_id = dept_id;
    }
    if(branch_id!=''){
      params.branch_id = branch_id;
    }
    params.all_sbu = this.sbu_all_selected;
    params.all_company = this.company_all_selected;
    params.all_branch = this.branch_all_selected;

    params.sbu_ids = this.sbu_selected.join(',');
    params.company_ids = this.company_selected.join(',');
    params.branch_ids = this.branch_selected.join(',');
    params.classification_ids = this.filter_stage_selected.join(',');
    this.navCtrl.push(ListProjectPage,{
      params : params
    });
  }


  confirmLogout() {
    const confirm = this.alertCtrl.create({
      title: 'Yakin akan keluar ?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {

          }
        },
        {
          text: 'Ya',
          handler: () => {
            this.logout();
          }
        }
      ]
    });
    confirm.present();
  }

  logout(){
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }

  toProfile(){
    this.navCtrl.push(ProfilePage);
  }

 
}



// WEBPACK FOOTER //
// ./src/pages/marketing/dashboard/page.ts